export function generateQueryString(arr) {
  if (arr.length < 1) return "";
  let str = "";
  for (let i = 0; i < arr.length; i++) {
    str += i === 0 ? `?${arr[i]}` : `&${arr[i]}`;
  }

  return str;
}

export function parseCampaignIds(campNames, campaignId) {
  let campId = "";

  if(campNames && campaignId) {
    campId = `${campNames},${campaignId}`;
  } else if(campNames && !campaignId) {
    campId = campNames;
  } else if(!campNames && campaignId) {
    campId = campaignId;
  }
  else {
    campId = "";
  }
  return campId;
}